<template>
    <div class="roma-page-content fill-height">
        <v-container class="form-new-activity">
            <!-- Label -->
            <v-row class="align-center justify-space-between">
                <v-col cols="auto">
                    <h2 class="form-new-activity__title d-flex align-center">
                        <template v-if="updateItem">
                            <v-icon>icon-create-activity</v-icon>
                            <span class="ml-2">Editar Actividad</span>
                        </template>
                        <template v-else>
                            <v-icon>icon-create-activity</v-icon>
                            <span class="ml-2">Crear Actividad</span>
                        </template>
                    </h2>
                </v-col>
                <v-col cols="auto" class="d-flex justify-end">
                    <v-btn
                        color="white"
                        fab
                        class="close-btn"
                        @click="goBack()"
                        small
                    >
                        <img src="@/assets/images/close.svg" alt="" />
                        <!-- <v-icon color="red">mdi-close</v-icon> -->
                    </v-btn>
                </v-col>
            </v-row>

            <!-- code title activity-type -->
            <v-row>
                <v-col cols="4" class=" pb-0">
                    <v-text-field
                        dense
                        v-model="code"
                        :rules="requiredRules"
                        name="code"
                        label="Código"
                        outlined
                        rounded
                    ></v-text-field>
                </v-col>
                <v-col cols="8" class=" pb-0">
                    <v-text-field
                        dense
                        v-model="title"
                        :rules="requiredRules"
                        name="title"
                        label="Título"
                        outlined
                        rounded
                    ></v-text-field>
                </v-col>

                <!-- TASK -->
                <v-col cols="6" md="2">
                    <v-checkbox
                        v-model="task"
                        label="Incluye Tarea"
                    ></v-checkbox>
                </v-col>

                <v-col v-if="task" cols="12" md="12">
                    <v-row>

                        <v-col cols="12" md="2">
                                <v-text-field
                                    dense
                                    min="0"
                                    max="7"
                                    :rules="rules.maxScore"
                                    label="Puntaje Máximo"
                                    outlined
                                    rounded
                                    v-model="maxScore"
                                    type="number"
                                ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="2">
                                <v-text-field
                                    dense
                                    min="0"
                                    max="100"
                                    :rules="rules.percentageRequirement"
                                    label="% Exigencia"
                                    outlined
                                    rounded
                                    v-model="percentageRequirement"
                                    type="number"
                                ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="3">
                            <v-select
                                outlined
                                rounded
                                dense
                                v-model="ratingScale"
                                label="Escala de Calificación"
                                :items="this.lessonInfo.ratingScale"
                                :item-text="item => item.name"
                                :item-value="item => item.id"
                                :rules="requiredRules"
                                prepend-icon="mdi-equalizer"
                            ></v-select>
                        </v-col>

                        <v-col cols="12" md="3">
                            <v-select
                                outlined
                                rounded
                                dense
                                v-model="taskType"
                                label="Tipo Calificación"
                                :items="taskTypes"
                                :rules="requiredRules"
                                prepend-icon="mdi-equalizer"
                            ></v-select>
                        </v-col>

                        <v-col cols="12" md="2">
                            <v-menu
                                ref="menu"
                                v-model="menuDatePicker"
                                :close-on-content-click="false"
                                :return-value.sync="date"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        outlined
                                        rounded
                                        dense
                                        v-model="deadline"
                                        label="Fecha entrega"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="deadline"
                                    no-title
                                    scrollable
                                    :min="nowDate"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="menu = false"
                                    >
                                        Cancelar
                                    </v-btn>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.menu.save(deadline)"
                                    >
                                        aceptar
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-col>

                <!-- Tutorial -->
                <v-col cols="6">
                    <v-checkbox
                        v-model="instructions"
                        :value="instructions"
                        label="Adicionar Instructivo"
                    ></v-checkbox>
                </v-col>

                <v-col cols="12" v-if="instructions">
                    <v-row>
                        <v-col>
                            <TipTap
                                placeholder="Instructivo"
                                :data="setInstruction"
                                :updateMode="{
                                    status: $route.params.id ? true : false,
                                    currentSelected: $route.params.id
                                        ? this.instructionsContent
                                        : ''
                                }"
                            />
                        </v-col>
                    </v-row>
                </v-col>

                <v-col cols="12">
                    <v-select
                        dense
                        v-model="activity"
                        :items="getActivitiesTypes"
                        :item-text="item => item.name"
                        :item-value="item => item.activityTypeId"
                        label="Tipo de actividad"
                        outlined
                        rounded
                        :rules="requiredRules"
                    ></v-select>
                </v-col>
            </v-row>

            <RomaDynamicResource
                :data="setDynamicResourceContent"
                :content="dynamicResourceContent"
                :resourcesTO="resourcesTO"
            />

            <!-- task by student -->
            <!-- <v-row class="mt-3">
            <v-col cols="4" class="mt-2 no-padding col-29">
                <h3 class="font-weight-regular">
                <v-icon>icon-create-activity</v-icon>
                <span class="ml-8 title-check">Recibir tareas del estudiante</span>
                </h3>
            </v-col>
            <v-col class="no-padding" cols="1">
                <v-checkbox v-model="receive" :value="receive" class="mb-3"></v-checkbox>
            </v-col>
            <v-col cols="4" sm="4" md="4" class="no-padding" v-if="receive">
                <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                min-width="290px"
                >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        dense
                    v-model="date"
                    label="Desde"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    ></v-text-field>
                </template>
                <v-date-picker v-model="date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                </v-date-picker>
                </v-menu>
            </v-col>
        </v-row> -->

            <!-- Shared with Students -->
            <!-- <v-row class="custom-checkbox-wrapper">
                <v-col cols="auto" offset="1">
                    <v-checkbox
                        class="subtitle-label"
                        v-model="sharedAll"
                        label="Compartir con todos"
                        :value="sharedAll"
                    ></v-checkbox>
                </v-col>
                <v-col cols="auto">
                    <v-checkbox
                        class="subtitle-label"
                        v-model="sharedSome"
                        label="Compartir con algunos estudiantes"
                        :value="sharedSome"
                    ></v-checkbox>
                </v-col>
            </v-row>

            <v-row v-if="sharedSome" class="fixed-height">
                <v-col cols="12">
                    <v-select
                        v-model="student"
                        :items="students"
                        :item-text="item => getfullName(item)"
                        :item-value="item => item"
                        label="Selecciona los estudiantes"
                        outlined
                        rounded
                        multiple
                        chips
                        :rules="requiredRules"
                    ></v-select>
                </v-col>
            </v-row> -->

            <!-- pruebas Frederick -->
            <!-- <v-row>
            <v-radio-group
                v-model="radioGroup"
                :column="false"
                class="shared-radios"
            >
                <v-radio label="Compartir con todos" :value="1"></v-radio>
                <v-radio
                    class="ml-5"
                    label="Compartir con algunos estudiantes"
                    :value="2"
                ></v-radio>
            </v-radio-group>
        </v-row> -->

            <!-- save form -->
            <!-- :disabled="!availableSubmit" -->
            <v-row class="justify-center" v-if="!submitted">
                <v-btn
                    rounded
                    color="accent"
                    large
                    :disabled="!availableSubmit"
                    class="roma-btn"
                    @click="createOrUpdate()"
                >
                    <span class="text-capitalize mr-4">Guardar</span>
                    <v-icon>icon-save-white</v-icon>
                </v-btn>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import TipTap from "@/components/commons/RomaTipTap.vue";
import RomaDynamicResource from "@/components/commons/RomaDynamicResource";
import { mapActions, mapGetters } from "vuex";

export default {
    props: {
        updateItem: {
            default: null
        }
    },
    name: "RomaFormNewActivity",
    data() {
        return {
            submitted: false,
            radioGroup: 1,
            date: new Date().toISOString().substr(0, 10),
            menu: false,
            modal: false,
            menu2: false,
            dialog: false,
            receive: false,
            sharedAll: true,
            sharedSome: false,
            task: false,
            maxScore: "",
            percentageRequirement: "60",
            ratingScale: 4,
            taskType: null,
            taskTypes: ["NOTA", "LOGRO", "NOTA Y LOGRO"],
            scaleTypes: [],
            menuDatePicker: null,
            nowDate: new Date().toISOString().slice(0, 10),
            deadline: null,
            instructions: false,
            editorIsEmpty: false,
            activityId: null,
            activity: "",
            code: "",
            title: "",
            type: "",
            resource: "",
            resourcesTO: [],
            description: "",
            instructionsContent: "",
            student: [],
            activities: ["Tipo 1", "Tipo 2", "Tipo 3", "Tipo 4"],
            students: [
                {
                    id: 1,
                    firstName: "abc",
                    middleName: "abc",
                    motherLastName: "xyz",
                    fatherLastName: "xyz"
                },
                {
                    id: 2,
                    firstName: "luis",
                    middleName: "asd",
                    motherLastName: "qwe",
                    fatherLastName: "qwe"
                },
                {
                    id: 3,
                    firstName: "qwe",
                    middleName: "asd",
                    motherLastName: "rty",
                    fatherLastName: "xcv"
                }
            ],
            requiredRules: [v => !!v || "Este campo es requerido"],
            rules: {
                maxScore: [
                    v => !!v || "Este campo es requerido",
                    v => v <= 999 || "El campo debe ser menor o igual a 999"
                ],
                percentageRequirement: [
                    v => !!v || "Este campo es requerido",
                    v => v <= 100 || "El campo debe ser menor o igual a 100"
                ]
            },
            dynamicResourceContent: ""
        };
    },
    async mounted() {

        console.log("Lesson Id asociada a la actividad:",this.lessonId);
        await this.getInfoByLessonId(this.lessonId)
            .then(() => {
                this.destructuringStudentName();
            })
            .catch(e => {
                console.info("error", e);
            });

        if (this.updateItem) {
            await this.actionGetActivity(this.updateItem);
        } else {
            await this.actionResetActivity();
        }

        await this.actionGetActivitiesTypes();

        this.$route.params.id ? this.updateMode(this.getActivity) : false;
    },
    destroyed() {
        this.actionResetResources();
    },
    components: {
        TipTap,
        RomaDynamicResource
    },
    computed: {
        availableSubmit() {
            let availableSubmit =
                !!this.title &&
                !!this.code &&
                !!this.activity &&
                !!this.getResources.length;

            if (this.task) {
                availableSubmit = availableSubmit && !!this.taskType;
            }

            // console.log(availableSubmit);
            return availableSubmit;
        },
        ...mapGetters({
            getActivitiesInfo: "getActivitiesInfo",
            getActivitiesTypes: "getActivitiesTypes",
            getResources: "getResources",
            getActivity: "getActivity",
            getLesson: "getLesson",
            lessonInfo: "getLessonInformation"
        }),

        lessonId() {
            return this.getLesson.lessonId;
        }
    },
    watch: {
        sharedSome() {
            this.sharedAll = !this.sharedAll;
        }
    },
    methods: {
        ...mapActions({
            toastSuccess: "toastSuccess",
            toastError: "toastError",
            addNewActivity: "addNewActivity",
            actionUpdateActivity: "actionUpdateActivity",
            getInfoByLessonId: "getInfoByLessonId",
            actionGetActivitiesTypes: "actionGetActivitiesTypes",
            actionGetActivity: "actionGetActivity",
            actionResetActivity: "actionResetActivity",
            actionResetResources: "actionResetResources"
        }),
        destructuringStudentName() {
            const { students } = this.getActivitiesInfo;
            const array = [];
            students.forEach(student => {
                array.push({
                    personId: student.personId,
                    firstName: this.capitalizeFirstLetter(
                        student.fullName.split(" ")[2].toLowerCase()
                    ),
                    middleName: this.capitalizeFirstLetter(
                        student.fullName.split(" ")[3] ? student.fullName.split(" ")[3].toLowerCase() : ""
                    ),
                    motherLastName: this.capitalizeFirstLetter(
                        student.fullName.split(" ")[1].toLowerCase()
                    ),
                    fatherLastName: this.capitalizeFirstLetter(
                        student.fullName.split(" ")[0].toLowerCase()
                    )
                });
            });
            this.students = array;
        },
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        toggleSharedAll() {
            this.sharedAll = !this.sharedAll;
        },
        toggleSharedSome() {
            this.sharedSome = this.sharedSome && this.sharedAll ? false : true;
        },
        setDynamicResourceContent(data) {
            this.dynamicResourceContent = data;
        },
        getfullName(fullname) {
            if (
                fullname.motherLastName == fullname.fatherLastName &&
                fullname.firstName == fullname.middleName
            ) {
                return `${fullname.firstName} ${fullname.fatherLastName} ${fullname.motherLastName[0]}.`;
            } else if (fullname.motherLastName == fullname.fatherLastName) {
                return `${fullname.firstName} ${fullname.middleName[0]}. ${fullname.fatherLastName}`;
            } else {
                return `${fullname.firstName} ${fullname.fatherLastName}`;
            }
        },
        setDescription(description) {
            this.description = description;
        },
        setInstruction(instructions) {
            this.instructionsContent = instructions;
        },
        isEmpty() {
            console.info(!!this.description);
            this.editorIsEmpty = !!(
                (this.description === "") |
                (this.description === "<p></p>")
            );
        },
        sortResources() {
            const recursos = [];

            const files = [];

            this.getResources.forEach(element => {
                const resourceType = element.data.type;
                let link = null;
                // let file = null;
                let fileName = null;
                let path = null;
                let description = null;

                switch (resourceType) {
                    // Archivo
                    case "FILE":
                        if (element.content.size > 0) {
                            files.push(element.content);
                        }

                        fileName = element.content.name;
                        path = element.path;
                        break;

                    // Enlace Externo
                    case "EXTERNAL_LINK":
                        link = element.content;
                        break;

                    // Video Enlace
                    case "VIDEO_LINK":
                        link = element.content;
                        break;

                    // Texto Enriquecido
                    case "TEXT":
                        description = element.content;
                        break;

                    // Enlace Externo Embebido
                    case "EXTERNAL_LINK_EMBEDDED":
                        link = element.content;
                        break;

                    default:
                        break;
                }

                recursos.push({
                    resourcesId: element.resourcesId,
                    resourceTypeId: element.data.resourceTypeId,
                    link,
                    path,
                    fileName,
                    description
                });
            });

            console.info("## FILES ##", files);
            console.info("## RECURSOS ##", recursos);

            return [recursos, files];
        },
        createFormData(recursos, files) {
            const form = new FormData();

            if (this.activityId) {
                form.append("activityId", this.activityId);
            }

            if (this.task) {
                form.append(
                    "taskType",
                    this.taskType == "NOTA Y LOGRO"
                        ? "NOTA_LOGRO"
                        : this.taskType
                );

                const date = new Date(this.deadline);
                form.append("deadline", date.toISOString());
            }

            form.append("code", this.code);
            form.append("title", this.title);
            form.append("instructive", this.instructionsContent);
            form.append("lessonId", this.getLesson.lessonId);
            form.append("activityTypeId", this.activity);
            form.append("resourcesJson", JSON.stringify(recursos));
            form.append("sharedAll", this.sharedAll);

            form.append("maxScore", this.maxScore == null ? '' : this.maxScore );
            form.append("percentageRequirement", this.percentageRequirement);
            form.append("ratingScale", this.ratingScale);

            this.student.forEach(student => {
                form.append("studentsId", student.personId);
            });

            files.forEach((element, i) => {
                form.append("files", files[i]);
            });

            return form;
        },
        createNewActivity() {            
            const [recursos, files] = this.sortResources();

            const formData = this.createFormData(recursos, files);

            console.log("### CREAR ACTIVIDAD ###");
            for (const pair of formData.entries()) {
                console.log(pair[0] + ", " + pair[1]);
            }

            this.addNewActivity(formData)
                .then(() => {
                    this.toastSuccess({
                        message: `Se creo la Actividad "${this.code} ${this.title}"`
                    });
                    this.goBack();
                })
                .catch(err => {
                    console.info("error", err);
                    this.submitted = false;
                });
        },
        updateActivity() {
            const [recursos, files] = this.sortResources();

            const formData = this.createFormData(recursos, files);

            console.log("### ACTUALIZAR ACTIVIDAD ###");
            for (const pair of formData.entries()) {
                console.log(pair[0] + ", " + pair[1]);
            }
            this.actionUpdateActivity(formData)
                .then(() => {
                    this.toastSuccess({
                        message: `Se actualizo la Actividad "${this.code} ${this.title}"`
                    });
                    this.goBack();
                })
                .catch(err => {
                    console.info("error", err);
                    this.submitted = false;
                });
        },
        createOrUpdate() {
            this.submitted = true;
            this.$route.params.id
                ? this.updateActivity()
                : this.createNewActivity();
        },
        toggleModal() {
            this.dialog = !this.dialog;
        },
        updateMode(data) {
            if (data) {
                this.code = data.code;
                this.title = data.title;
                this.activity = data.activityTypeTO.activityTypeId;
                this.instructionsContent = data.instructive
                    ? data.instructive
                    : "";
                this.instructions = data.instructive ? true : false;
                this.activityId = data.activityLessonId;
                this.resourcesTO = data.resourcesTO;

                this.task = data.task;//data.deadline ? true : false;

                this.ratingScale = data.ratingScale;
                this.percentageRequirement = data.percentageRequirement;
                this.maxScore = data.maxScore;

                this.taskType =
                    data.evaluationFormat == "NOTA_LOGRO"
                        ? "NOTA Y LOGRO"
                        : data.evaluationFormat;
                this.deadline =
                    data.deadline != null
                        ? new Date(data.deadline)
                              .toISOString()
                              .slice(0, 10)
                              .slice(0, 10)
                        : null;
            }
        }
    }
};
</script>

<style lang="scss">
.form-new-activity {
    .shared-radios {
        // background-color: #bada55;
        .v-radio {
            flex-direction: row-reverse;
        }
        .v-input--selection-controls__input {
            margin-left: 1rem;
            // background-color: #bada55;
        }
    }
    &__subtitle {
        font-size: 19px;
    }
    .subtitle-label {
        .v-label {
            font-size: 18px;
        }
    }
    .custom-checkbox-wrapper {
        .v-input {
            &--checkbox {
                .v-input__slot {
                    flex-direction: row-reverse;
                    .v-label {
                        flex: 0 1 max-content;
                        margin-right: 1rem;
                    }
                }
            }
        }
    }
    .fixed-height {
        .v-select__selections {
            min-height: 56px !important;
        }
    }
    @media (min-width: 1904px) {
        &__title {
            font-size: 36px;
        }
    }
    @media (min-width: 1264px) and (max-width: 1903px) {
        &__title {
            font-size: 31px;
        }
    }
    @media (min-width: 960px) and (max-width: 1263px) {
        &__title {
            font-size: 25px;
        }
    }
    @media (min-width: 600px) and (max-width: 959px) {
    }
    @media (max-width: 599px) {
        &__title {
            font-size: 17px;
        }
    }
}
</style>
